(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awakndland-collection-intro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sizeAliases = {
      small: 's',
      sm: 's',
      s: 's',
      medium: 'm',
      med: 'm',
      m: 'm',
      large: 'l',
      lg: 'l',
      l: 'l',
      xlarge: 'xl',
      'x-large': 'xl',
      xl: 'xl',
      xxlarge: '2xl',
      'xx-large': '2xl',
      xxl: '2xl',
      '2x': '2xl',
      '2xl': '2xl',
      xxxlarge: '3xl',
      'xxx-large': '3xl',
      xxxl: '3xl',
      '3x': '3xl',
      '3xl': '3xl',
      '4x': '4xl',
      '4xl': '4xl',
      '5x': '5xl',
      '5xl': '5xl',
      '6x': '6xl',
      '6xl': '6xl'
    };

    const normalize = (label) => {
      const key = label.trim().toLowerCase().replace(/\s+/g, '-');
      return sizeAliases[key] || key;
    };

    const getGroupLabel = (group) => {
      const summary = group.querySelector('summary');
      const heading = summary || group.querySelector('.facets__label, .mobile-facets__summary, .facets__heading');
      return heading ? heading.textContent.trim().toLowerCase() : '';
    };

    const tidySizeFilters = () => {
      document.querySelectorAll('.facets__panel, .mobile-facets__details').forEach((group) => {
        if (!getGroupLabel(group).includes('size')) return;

        group.querySelectorAll('.show-more-item').forEach((item) => {
          item.classList.remove('hidden');
          item.hidden = false;
        });

        group.querySelectorAll('show-more-button').forEach((button) => {
          button.hidden = true;
        });

        group.querySelectorAll('button, a').forEach((control) => {
          const controlText = control.textContent.trim().toLowerCase();
          if (controlText.includes('show more') || controlText.includes('show less')) {
            control.hidden = true;
          }
        });

        const seen = new Set();
        group.querySelectorAll('.facets__item, .mobile-facets__item').forEach((item) => {
          const label = item.querySelector('.facet-checkbox__text-label');
          const input = item.querySelector('input');
          if (!label) return;

          const canonical = normalize(label.textContent);
          if (seen.has(canonical) && !(input && input.checked)) {
            item.hidden = true;
            item.classList.add('awakndland-filter-duplicate');
          } else {
            seen.add(canonical);
            item.hidden = false;
            item.classList.remove('awakndland-filter-duplicate');
          }
        });
      });
    };

    const tidyPriceFilters = () => {
      document.querySelectorAll('.facets__panel, .mobile-facets__details').forEach((group) => {
        if (!getGroupLabel(group).includes('price')) return;

        group.querySelectorAll('p, span, small').forEach((node) => {
          if (node.querySelector('input, button, a')) return;

          const helperText = node.textContent.trim();
          if (/^the highest price is/i.test(helperText)) {
            node.classList.add('awakndland-filter-helper-hidden');
          }
        });
      });
    };

    const collapseDefaultFilterPanels = () => {
      document.querySelectorAll('.facets__panel, .mobile-facets__details').forEach((group) => {
        if (group.dataset.awakndlandCollapsedDefault === 'true') return;

        const hasActiveSelection = Boolean(group.querySelector('input:checked'));
        if (group.tagName.toLowerCase() === 'details' && !hasActiveSelection) {
          group.removeAttribute('open');
          group.classList.remove('menu-opening');
        }

        group.dataset.awakndlandCollapsedDefault = 'true';
      });
    };

    const tidyFilters = () => {
      collapseDefaultFilterPanels();
      tidySizeFilters();
      tidyPriceFilters();
    };

    tidyFilters();
    document.addEventListener('DOMContentLoaded', tidyFilters);
    document.addEventListener('shopify:section:load', tidyFilters);

    const observer = new MutationObserver(() => window.requestAnimationFrame(tidyFilters));
    observer.observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awakndland-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-awakndland-tabs]');

    for (const root of roots) {
      const heading = root.querySelector('[data-awakndland-tabs-heading]');
      const tabs = Array.from(root.querySelectorAll('[data-awakndland-tabs-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-awakndland-tabs-panel]'));

      for (const tab of tabs) {
        tab.addEventListener('click', () => {
          const targetId = tab.getAttribute('aria-controls');

          for (const item of tabs) {
            const isActive = item === tab;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          }

          for (const panel of panels) {
            const isActive = panel.id === targetId;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
          }

          if (heading && tab.dataset.heading) {
            heading.textContent = tab.dataset.heading;
          }
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awakndland-header-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHeader = (header) => {
      if (!header || header.dataset.awakndlandHeaderReady === 'true') return;

      const search = header.querySelector('[data-awakndland-header-search]');
      const searchInput = search?.querySelector('input[type="search"]');
      const searchSummary = search?.querySelector('summary');
      const shopMenus = Array.from(header.querySelectorAll('[data-awakndland-header-shop]'));
      if (!search || !searchInput || !searchSummary) return;

      header.dataset.awakndlandHeaderReady = 'true';

      search.addEventListener('toggle', () => {
        if (!search.open) return;
        shopMenus.forEach((menu) => {
          menu.open = false;
        });
        window.requestAnimationFrame(() => searchInput.focus());
      });

      shopMenus.forEach((menu) => {
        menu.addEventListener('toggle', () => {
          if (menu.open) search.open = false;
        });
      });

      search.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        search.open = false;
        searchSummary.focus();
      });

      document.addEventListener('click', (event) => {
        if (!search.open) return;
        if (search.contains(event.target)) return;
        search.open = false;
      });
    };

    const bootHeaders = () => {
      document.querySelectorAll('.awakndland-header-nav').forEach(initHeader);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootHeaders);
    } else {
      bootHeaders();
    }

    document.addEventListener('shopify:section:load', bootHeaders);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
